module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "login text-left"
  }, [_c('headerBlock', {
    attrs: {
      "authUser": null
    },
    on: {
      "logout": function($event) {}
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('alert', {
    attrs: {
      "placement": "top",
      "duration": "5000",
      "type": "warning",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.alertWarning.visible),
      callback: function($$v) {
        _vm.$set(_vm.alertWarning, "visible", $$v)
      },
      expression: "alertWarning.visible"
    }
  }, [_c('span', {
    staticClass: "icon-info-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.alertWarning.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.alertWarning.text))])]), _vm._v(" "), _c('alert', {
    attrs: {
      "placement": "top",
      "duration": "5000",
      "type": "danger",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.alertError.visible),
      callback: function($$v) {
        _vm.$set(_vm.alertError, "visible", $$v)
      },
      expression: "alertError.visible"
    }
  }, [_c('span', {
    staticClass: "icon-info-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.alertError.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.alertError.text))])]), _vm._v(" "), _c('alert', {
    attrs: {
      "placement": "top",
      "duration": "3000",
      "type": "success",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.alertSuccess.visible),
      callback: function($$v) {
        _vm.$set(_vm.alertSuccess, "visible", $$v)
      },
      expression: "alertSuccess.visible"
    }
  }, [_c('span', {
    staticClass: "icon-ok-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.alertSuccess.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.alertSuccess.text))])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.sendAuth()
      }
    },
    model: {
      value: (_vm.authData),
      callback: function($$v) {
        _vm.authData = $$v
      },
      expression: "authData"
    }
  }, [_c('h1', [_vm._v("Login")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row align-items-baseline"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.authData.loginInput),
      expression: "authData.loginInput"
    }],
    staticClass: "col-sm-4 col-md-5 col-lg-4 form-control",
    attrs: {
      "placeholder": "login",
      "id": "txtUsername"
    },
    domProps: {
      "value": (_vm.authData.loginInput)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.authData, "loginInput", $event.target.value)
      }
    }
  })]), _vm._v(" "), (!_vm.showLoginMain) ? _c('div', {
    staticClass: "saml_login_block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('b-button', {
    staticClass: "offset-sm-3 offset-md-4 offset-lg-3",
    attrs: {
      "variant": "primary",
      "id": "btnNext"
    },
    on: {
      "click": _vm.checkSuffix
    }
  }, [_vm._v("Next")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.showLoginMain) ? _c('div', {
    staticClass: "main_login_block"
  }, [_c('div', {
    staticClass: "row align-items-baseline"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.authData.passwordInput),
      expression: "authData.passwordInput"
    }],
    staticClass: "col-sm-4 col-md-5 col-lg-4 form-control",
    attrs: {
      "type": "password",
      "placeholder": "password",
      "id": "txtPassword"
    },
    domProps: {
      "value": (_vm.authData.passwordInput)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.authData, "passwordInput", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('b-button', {
    staticClass: "offset-sm-3 offset-md-4 offset-lg-3",
    attrs: {
      "variant": "primary",
      "id": "btnLogin",
      "type": "submit"
    }
  }, [_vm._v("login")])], 1)]) : _vm._e()])])])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-sm-3 col-md-4 col-lg-3"
  }, [_c('b', [_vm._v("Login")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-sm-3 col-md-4 col-lg-3"
  }, [_c('b', [_vm._v("Password")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0daf7a0d","hasScoped":true}!./src/components/login/login.component.html
// module id = 533
// module chunks = 1